var myDropzone = false;
EMMY.blurSave = {
  init: function () {
    EMMY.blurSave.imisCheckOnLoad();
    EMMY.blurSave.activeAjaxUpdate = true;
    EMMY.blurSave.autoCompleteUpdate = false;
    EMMY.blurSave.thirdPartyUpload();
    EMMY.blurSave.initalMaxWordChecker();

    if($('.admin-save').length > 0) {
      EMMY.blurSave.adminSaver();
    } else {
      EMMY.blurSave.submitter(false);
    }
    $(".save-button, a#SaveButton").on('click', function(e) {
      e.preventDefault();
      var formID = $('#entry-fulldetails-form');
      EMMY.blurSave.ajaxCall(formID, false);
      EMMY.entrants.ajaxBlurEntrant(true);

      $(".save-button, a#SaveButton").attr("style","opacity:0.5; -moz-opacity:0.5; filter:alpha(opacity=50)");
      setTimeout(function(){ window.location.href = '/entries'; }, 2000);
    });
    $(document).on('keyup', '.blurSave:not(.entryAdmin) .form-control.word-count', function(e) {
      var that = $(this);
      var includeSave = false;
      _wordChecker(that, includeSave);
    });
  },
    initalMaxWordChecker: function() {
       $('.form-control.word-count').each(function(i,v) {
           var that = $(this);
           _wordChecker(that);
       })
    },
  thirdPartyUpload: function() {
    $('.file_upload_email').on('keyup', function(e) {
      $(this).closest('.form-group-beside').find('.email-send-message').css('opacity', 0);
      $(this).closest('.form-group-beside').find('button').removeAttr('disabled');
    });

    $('.admin-send-thirdparty-upload').on('click', function(e) {
      e.preventDefault();

      var fileid = $(this).data('file-id');
      var email = $('.file_upload_email.file-id-'+fileid).val();

      $('.file_upload_email.file-id-'+fileid).closest('.form-group-beside').find('.email-send-message').css('opacity', 1);
      $.ajax({
        url: '/uploadlink_store/' + $(this).data('entry-id'),
        type: 'put',
        data: {fileid: fileid, email: email},
        success: function (data) {
          // need some way to show success
          $('.file_upload_email.file-id-'+fileid).css('background-color','#00d60040');
          $('.file_upload_email.file-id-'+fileid).closest('.form-group-beside').find('.email-send-message').text('Sent');
          $('.file_upload_email.file-id-'+fileid).closest('.form-group-beside').find('button').attr('disabled', true);
        }
      });
    });
  },
  submitter: function(reload) {
    var formID = $('#entry-fulldetails-form');
    if (formID.val() != undefined) {
      EMMY.blurSave.actualAjaxSaving(formID, reload);
    }
  },
  actualAjaxSaving: function(formID, reloadForm) {
    var allClasses = dataList = false;
    if($("#entry-fulldetails-form .form-group-beside").val() != undefined) {
      var dataList = $('#entry-fulldetails-form').find(".form-group-beside, .form-group-beside-hold, .full-instructions-wrapper").map(function() {
        return $(this).data("dynamic-name");
      }).get();
      if(dataList.length > 0) {
        allClasses = '.'+dataList.join(",.");
      }
    }

    formID.find('.form-control').on('change', function (e) {
        var that = $(this);
      if($(this).hasClass('autocomplete-item')) {
        EMMY.blurSave.autoCompleteUpdate = true;
      }
    EMMY.blurSave.laaStationNameAutoFill(that);

        if(allClasses) {
        var changedElementGroup = $(this).attr('class').split(' ');
        var dynamicElementClass = changedElementGroup[changedElementGroup.length - 1];
        if ($(this).hasClass('toggle')) {
          var valueOfDynamicField = $(this).parent().find('.form-control:checked').val();
        } else {
          var valueOfDynamicField = $(this).val();
        }

        // This is the code when the dynamic field equals the trigger result
        // In this case we really just have to set the required fields BACK to their required state.
        var dynamicDataEqual = $('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value="' + valueOfDynamicField + '"]');
        dynamicDataEqual.show();

        dynamicDataEqual.each(function (i, v) {
          $(this).removeClass('required');
          $(this).find('.form-control, .requiredFile').removeAttr('required');
          if ($(this).find('.form-control').hasClass('toggle')) {
            $(this).find('.form-control').removeAttr('checked');
            $(this).find('.toggle-js span').removeClass('active');
          } else if ($(this).find('.form-control').hasClass('select2-hidden-accessible')) {
            $(this).find('.form-control').val('').trigger('change');
          } else if ($(this).find('.form-control').hasClass('checkbox-field-form')) {
            $(this).find('.form-control').removeAttr('checked');
          } else if ($(this).hasClass('episode_name_block')) {
            $(this).find('.episode_details:not(:first)').remove();
            $(this).find('.episode_details .form-control').val('');
            $('.episode_name_block').each(function(i,v) {
              EMMY.customFields.initialEpisodeChecker(this);
            });
          } else {
            $(this).find('.form-control').val('');
          }
          if ($(this).hasClass('dynamic-required')) {
            $(this).find('.form-control, .requiredFile').attr('required', true);
          }
        });

        // This is the code when the dynamic field DOES NOT equals the trigger result
        // In this case we must hide the field, remove the required attribute, required class (if set) and clear the data from the field.
        var dynamicDataNotEqual = $('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value!="' + valueOfDynamicField + '"]');
        dynamicDataNotEqual.hide();

        dynamicDataNotEqual.each(function (i, v) {
          $(this).removeClass('required');
          $(this).find('.form-control, .requiredFile').removeAttr('required');
          if ($(this).find('.form-control').hasClass('toggle')) {
            $(this).find('.form-control').removeAttr('checked');
            $(this).find('.toggle-js span').removeClass('active');
          } else if ($(this).find('.form-control').hasClass('select2-hidden-accessible')) {
            $(this).find('.form-control').val('').trigger('change');
          } else if ($(this).find('.form-control').hasClass('checkbox-field-form')) {
            $(this).find('.form-control').removeAttr('checked');
          } else if ($(this).hasClass('episode_name_block')) {
            $(this).find('.episode_details:not(:first)').remove();
            $(this).find('.episode_details .form-control').val('');
            $('.episode_name_block').each(function(i,v) {
              EMMY.customFields.initialEpisodeChecker(this);
            });
          } else if((($(this).hasClass('uploaded')) && ($(this).hasClass('uploaded'))) || ($(this).find('.dz-max-files-reached').val() != undefined)) {
            // two if statements for when the dz is initilizaed on load and by ajax upload.
            // Here we delete the uploaded file, if necessary.
            // The actual delete happens after blur save, because we trigger a save when they toggle the conditional.
            // However, the delete creates a reload, so we don't want a race-condition so we do that in the after ajax.
            var idVal = $(this).attr('id');
            myDropzone = Dropzone.forElement('#' + idVal + ' .dropzone');
            customFieldIdHolder = $('#' + idVal).find('.form-control').data('value');
          } else {
            $(this).find('.form-control').val('');
          }
        });
      }

      if($(this).hasClass('body_of_work')) {
        reloadForm = true;
      }
      // This saves the field if the word count is below the maximum (after change)
      if($(this).hasClass('word-count')) {
        EMMY.blurSave.maxWordCountRemoveOver($(this));
        EMMY.blurSave.ajaxCall(formID, reloadForm);
      } else {
        EMMY.blurSave.ajaxCall(formID, reloadForm);
      }
    });

    // This shows the too many character message after keyup
    formID.find('.form-control.word-count').on('keyup, focusout', function(e) {
      var words = 0;
      var maxWords = Number($(this).data('max-word-count'));
      if($(this).val()) {
        words = window.countWords($(this).val());
      }
      if (words > maxWords) {
        $(this).addClass('too-many-words');
        $(this).next('.overlimit-word-count').show();
      } else {
        $(this).removeClass('too-many-words');
        $(this).next('.overlimit-word-count').hide();
      }
    });

    // Need to show the dependent fields here on load
    if(dataList) {
      $.each(dataList, function(i,v) {
        var dynamicElementClass = v;
        var dynamicNameID = '#field_id_' + v;
        var valueOfDynamicField = $(dynamicNameID).find('.form-control:checked').val();
        var dynamicDataEqual = $('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value="' + valueOfDynamicField + '"]');
        dynamicDataEqual.show();
        $('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value!="' + valueOfDynamicField + '"]').find('.form-control, .requiredFile').removeAttr('required');
      });
    }

  },
  ajaxCall: function(formID, reloadForm) {
    if (!EMMY.blurSave.activeAjaxUpdate) {
      return;
    }
    EMMY.blurSave.activeAjaxUpdate = false;

    // Truncate max word count to MAX number if over before saving
    $('.blurSave:not(.entryAdmin) #entry-fulldetails-form .form-control.word-count').each(function(i,v) {
      var that = $(this);
      EMMY.blurSave.maxWordCountRemoveOver(that);
    });

    var dataForm = '';
    if(EMMY.blurSave.autoCompleteUpdate == true) {
      setTimeout(function() {
        // console.log('we do this because the autocomplete selection fires after the change')
        if($('.entryAdmin').val() == undefined) {
          dataForm = formID.serialize();
          EMMY.blurSave.ajaxStuff(dataForm,reloadForm)
        }
      }, 100)
    } else {
      if($('.entryAdmin').val() == undefined) {
        dataForm = formID.serialize();
        EMMY.blurSave.ajaxStuff(dataForm, reloadForm)
      }
    }
  },
  ajaxStuff: function(dataForm, reloadForm) {
    $.ajax({
      url: '/entry/' + EMMY.entrants.entryId,
      type: 'put',
      data: dataForm,
      success: function (data) {
        //console.log('blur saved', reloadForm);
        EMMY.blurSave.activeAjaxUpdate = true;
        var mainWrapper = document.querySelector('.main');
        mainWrapper.className = 'main oneColumn col-8 col-md-10 editPage ' + data.status;
        EMMY.bindEntryDetails.init();
        $('.submission-status-value').text(data.status);
        if (reloadForm) {
          location.reload(true);
        }
        if(myDropzone) {
          // Do the dropzone delete now
          myDropzone.removeAllFiles()
        }
      }
    });
  },
  adminSaver: function() {
    $('.admin-save').on('click', function(e) {
      e.preventDefault();
      var currentTimestamp = Number($('#timestamp').text());
      EMMY.blurSave.ajaxTimestamp(currentTimestamp);
    });
  },
  ajaxTimestamp: function(currentTimestamp) {
    $.ajax({
      url: '/api/entry/' + EMMY.entrants.entryId + '/timestamp',
      type: 'get',
      success: function (data) {
        // console.log(currentTimestamp, 'timestamps', data.timestamp);
        if (currentTimestamp < data.timestamp) {
          // console.log('changes made', 'activate modal');
          $('body').addClass('modal-open-third');
          $('.reload').on('click', function(e) {
            // console.log('reload page');
            location.reload(true);
          });
          $('.confirm-save').on('click', function(e) {
            var formID = $('#entry-fulldetails-form');
            // EMMY.blurSave.ajaxCall(formID, false);
            dataForm = formID.serialize();
            EMMY.blurSave.ajaxStuff(dataForm, true)
            EMMY.entrants.ajaxBlurActiveSave = true;
            EMMY.entrants.ajaxBlurEntrant(true);
          });
        } else {
          var formID = $('#entry-fulldetails-form');
          dataForm = formID.serialize();
          EMMY.blurSave.ajaxStuff(dataForm, true)
          // EMMY.blurSave.ajaxCall(formID, false);
          EMMY.entrants.ajaxBlurActiveSave = true;
          EMMY.entrants.ajaxBlurEntrant(true);
          // console.log('save the data');
        }
      }
    });
  },
  imisCheckOnLoad: function() {
    $('.imis-entrant-form-field').each(function(i,v) {
      var imisValid = $(this).attr('data-imis-valid');
      var imisValue = $(this).val();
      if((imisValid == 'false') && (imisValue != '')) {
        $(this).closest('.form-group-beside').addClass('required');
        var entrantId = $(this).closest('.entrant-listing-item').find('.entrantIdVal').val();
        $('.entrant-listing-item-'+entrantId).addClass('needsAttention');
        $(this).addClass('imis-needsfixing');
      }
    });
  },
  maxWordCountRemoveOver: function(that) {
      // This no longer removes the words as of Awards-1514.
      // Now just controls show/hide over limit and required pieces
    if(that.val()) {
      var maxWords = Number(that.data('max-word-count'));
      var words = window.countWords(that.val());
      if(words <= maxWords) {
          that.removeClass('too-many-words');
          that.closest('.form-group-beside').removeClass('required');
          that.parent().find('.overlimit-word-count').hide();
      }
    }
  },
    laaStationNameAutoFill: function(that) {
        if(($('.laa-site').length > 0) && (that.hasClass('national_network') || that.hasClass('national_network_other'))) {
            teamNameAutoFillin = $('.national_network').val();
            if(teamNameAutoFillin == 'Other') {
                teamNameAutoFillin = $('.national_network_other').val();
            }
            if($('.entrant-form-wrapper').hasClass('team')) {
                $('.first_name').val(teamNameAutoFillin);
                // Need to save the entrant data after updating the team name
                EMMY.entrantsTeam.saveEntrantData();
                if($('.entryAdmin').val() == undefined) {
                    $('.first_name').prop('readonly', true)
                    $('.first_name').addClass('readonly-input')
                }
            } else {
                $('.first_name').removeAttr('readonly')
                $('.first_name').removeClass('readonly-input')
            }
        }
    }
};

function _wordChecker(that) {
  if (that.val().match(/\S+/g) == null) {
    that.removeClass('too-many-words');
    that.parent().find('.overlimit-word-count').hide();
    return;
  }
  var words = window.countWords(that.val());
  var maxWords = Number(that.data('max-word-count'));
  if (words > maxWords) {
    let numWords = Number(words) - Number(maxWords);
    if(numWords == 1) {
      numOver = numWords + ' word';
    } else {
      numOver = numWords + ' words';
    }
    that.addClass('too-many-words');
    that.parent().find('.overlimit-word-count span').text(numOver);
    that.parent().find('.overlimit-word-count').show();
  } else {
    that.removeClass('too-many-words');
    that.parent().find('.overlimit-word-count').hide();
  }
}
